/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Typography } from '@material-ui/core';
import { ImageAspectRatio } from 'models/forms';
import useStyles, { backGroundStyle } from './style';

interface Props {
  image: string | null;
  text: string | null;
  aspectRatio: ImageAspectRatio;
}

const Preview: React.FC<Props> = (props) => {
  const { image, text } = props;
  const imageBackgroudStyle = backGroundStyle(image || '');
  const classes = useStyles();

  return (
    <div style={imageBackgroudStyle}>
      {text && text.length > 0 && (
        <div className={classes.textContainer}>
          <Typography variant='body2' className={classes.text}>
            {text}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default Preview;
